export default __webpack_public_path__ + "static/media/jobTypeEmpty.aaddae6e.svg";